import { useLDClient } from 'launchdarkly-react-client-sdk';
import { ECHO_DESIGN_SYSTEM_FLAG } from '@/utils/constants';

/** Returns `true` when the Echo design system is enabled for the current LD context. */
const useEchoDesign = (): boolean => {
  const ldClient = useLDClient();
  return ldClient?.variation(ECHO_DESIGN_SYSTEM_FLAG, false) ?? false;
};

export default useEchoDesign;
